import styled from 'react-emotion';
import NavButton from '../NavButton/NavButton';

export const PopupZoomInButton = styled(NavButton)`
  position: absolute;
  bottom: 2%;
  left: 50.5%;
  z-index: 1;
`;

export const PopupZoomOutButton = styled(NavButton)`
  position: absolute;
  bottom: 2%;
  right: 50.5%;
  z-index: 1;
`;
